import { render, staticRenderFns } from "./Progope.vue?vue&type=template&id=057a40dc&scoped=true&"
import script from "./Progope.vue?vue&type=script&lang=ts&"
export * from "./Progope.vue?vue&type=script&lang=ts&"
import style0 from "./Progope.vue?vue&type=style&index=0&id=057a40dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057a40dc",
  null
  
)

export default component.exports